import { combineReducers } from "redux";
import userDetailReducer from "./UserDetailReducer";
import siteSettingsReducer from "./SitesettingReducer";
import authReducer from "./AuthReducer";
import assetsReducer from "./AssetsReducer";
import cmsReducer from "./CmsReducer";
import TradePairReducer from "./TradePairs/TradePairReducer";
import SpotTradePairReducer from "./TradePairs/SpotTradePairReducer";
import topMarketListReducer from "./TradePairs/MarketListReducer";
import NewTradePairReducer from "./TradePairs/NewTradePairReducer";
import TradePageSTPReducer from "./TradePage/SpotTradePairReducer";
import UserWalletReducer from "./UserWalletReducer";
import SpotTradeOrderBookReducer from "./TradePage/SpotOrderBookReducer";
import loginHistoryReducer from "./UserLoginHistoryReducer";
import assetListReducer from "./AssetListReducer";
import favTradePairReducer from "./TradePairs/FavTradePairReducer";
import spotOpenOrdersReducer from "./TradePage/SpotOrderHistoryReducer";
import TransferHistoryReducer from "./TradePage/TransactionHistoryReducer";
import notificationReducer from "./NotificationReducer";
import tradeHistoryReducer from "./TradePage/SpotTradeHistoryReducer";
import walletBalanceReducer from "./UserWalletBalanceReducer";
import walletListReducer from "./WalletListReducer";

import supportReducer from "./SupportReducer"
import walletReducer from "./PortfolioReducer";

import transactionReducer from "../Reducers/transactionReducer"
// import TradeHistory from "../Components/Orders/SpotOrder/TradeHistory";
import { tradeReducer } from "./TradePage/TradeReducer";
import adminBankListReducer from "./AdminBankListReducer";
import userBankListReducer from "./UserBankListReducer";

const appReducer = combineReducers({
  auth: authReducer,
  user: userDetailReducer,
  site: siteSettingsReducer,
  assets: assetsReducer,
  cms: cmsReducer,
  tradePair: TradePairReducer,
  spotTradePair: SpotTradePairReducer,
  topMarketList: topMarketListReducer,
  newListTP: NewTradePairReducer,
  tradeSTP: TradePageSTPReducer,
  userWallet: UserWalletReducer,
  stOrderBook: SpotTradeOrderBookReducer,
  loginHistory: loginHistoryReducer,
  assetList: assetListReducer,
  favTradePair: favTradePairReducer,
  walletList: walletListReducer,


  // spot openorders
  spotopenorder: spotOpenOrdersReducer,
  notification: notificationReducer,
  transfer: TransferHistoryReducer,
  tradeHistory: tradeHistoryReducer,
  walletBalance: walletBalanceReducer,

  support: supportReducer,
  // portfolio
  portfolio: walletReducer,
  transaction: transactionReducer,
  // trade-history 
  trade: tradeReducer,
  //admin bank list
  adminBank: adminBankListReducer,
  // user bank list
  userBank: userBankListReducer

});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT_CLEAR" || action.type === "REMOVE_LOGIN") {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
